import { defineComponent as _defineComponent } from 'vue'
import { computed, onActivated, ref } from "vue";
import router from "@/router";
import { useUserStore } from "@/stores/userStore";
import Page from "@/components/shared/Page.vue";
import SearchInput from "@/components/shared/inputs/SearchInput.vue";
import { RouterName } from "@/types";
import {
  useGetTopRelativePosition,
  useGetBottomRelativePosition,
} from "@/use/useGetRelativePosition";
import { useServiceStore } from "@/stores/serviceStore";


const __default__ = {
  name: "ReviewMain",
};

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  setup(__props, { expose: __expose }) {
  __expose();

const userStore = useUserStore();
const serviceStore = useServiceStore();

const logoPath = computed(() => serviceStore.serviceInfo?.logoPath);

const header = ref<HTMLElement>();
const catchPhrase = ref<HTMLElement>();
const catchPhraseFirst = ref<HTMLElement>();
const catchPhraseSecond = ref<HTMLElement>();

const statusBarHeightStr = computed(() =>
  getComputedStyle(document.documentElement).getPropertyValue(
    "--statusbar-height"
  )
);

const goToSearch = () => {
  router.push({ name: RouterName.ReviewSearch });
};

const shouldShowNotice = ref(true);
shouldShowNotice.value = userStore.shouldShowNotice;

const container = ref<HTMLElement>();
const scrollToTop = () => {
  container.value?.scrollTo({
    top: 0,
    behavior: "smooth",
  });
  resetScrollEvent();
};

/** 스크롤 이벤트 처리 */
const shouldHideIndicator = ref(false);
const shouldHideCatchPhraseFirst = ref(false);
const shouldHideCatchPhraseSecond = ref(false);
const shouldFixSearchInput = ref(false);
const onScrollEvent = (event: Event) => {
  const element = event.target as HTMLElement;
  const headerHeight = header.value?.offsetHeight ?? 54;
  const statusBarHeight = Number(statusBarHeightStr.value.slice(0, -2));

  shouldHideIndicator.value = element.scrollTop > 5;

  shouldHideCatchPhraseFirst.value =
    !!catchPhraseFirst.value &&
    useGetTopRelativePosition(catchPhraseFirst.value) <
      statusBarHeight + headerHeight + 16;

  shouldHideCatchPhraseSecond.value =
    !!catchPhraseSecond.value &&
    useGetTopRelativePosition(catchPhraseSecond.value) <
      statusBarHeight + headerHeight + 16;

  shouldFixSearchInput.value =
    !!catchPhrase.value &&
    useGetBottomRelativePosition(catchPhrase.value) <
      statusBarHeight + headerHeight;
};

const resetScrollEvent = () => {
  shouldHideIndicator.value = false;
  shouldHideCatchPhraseFirst.value = false;
  shouldHideCatchPhraseSecond.value = false;
  shouldFixSearchInput.value = false;
};

onActivated(() => {
  scrollToTop();
});

const __returned__ = { userStore, serviceStore, logoPath, header, catchPhrase, catchPhraseFirst, catchPhraseSecond, statusBarHeightStr, goToSearch, shouldShowNotice, container, scrollToTop, shouldHideIndicator, shouldHideCatchPhraseFirst, shouldHideCatchPhraseSecond, shouldFixSearchInput, onScrollEvent, resetScrollEvent, Page, SearchInput }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})